import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import useToast from '../hooks/useToast';
import ToastContainer from '../components/ToastContainer';
import { ROUTE_PATHS } from '../config/navigation';
import { hrSystems, onboardingJourney } from '../config/hrSystems';

const initialFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  department: '',
  position: '',
  startDate: '',
  birthDate: '',
  address: '',
  emergencyContact: '',
  officeLocation: '',
  extension: '',
  bio: '',
  expertise: '',
  password: '',
  confirmPassword: '',
  directoryVisible: true
};

const departmentOptions = [
  'Insan Kaynaklari',
  'Teknik Ofis',
  'Satin Alma',
  'Finans',
  'Muhasebe',
  'Idari Isler',
  'Bilgi Teknolojileri',
  'Proje Yonetimi'
];

const YeniCalisanPage = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const { toasts, addToast, removeToast } = useToast();

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.firstName || !formData.lastName || !formData.email || !formData.password) {
      addToast('Lutfen zorunlu alanlari doldurun.', 'error', 4000);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      addToast('Sifreler eslesmiyor.', 'error', 4000);
      return;
    }

    if (formData.password.length < 6) {
      addToast('Sifre en az 6 karakter olmali.', 'error', 4000);
      return;
    }

    try {
      setLoading(true);

      await api.createEmployee({
        ...formData,
        expertise: formData.expertise
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean)
      });

      addToast('Yeni calisan kaydi basariyla olusturuldu.', 'success', 4000);
      setFormData(initialFormData);
    } catch (error) {
      console.error('Create employee error:', error);
      addToast('Yeni calisan kaydi olusturulamadi.', 'error', 4000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-hr-page">
      <div className="container-fluid">
        <div className="modern-hr-header">
          <h1>Yeni Calisan Kaydi</h1>
          <p>Profil acilisi, onboarding akisi ve erisim ihtiyaclarini tek formda yonetin</p>
        </div>

        <div className="row g-4 mb-4">
          <div className="col-xl-8">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-user-plus"></i>
                  <h4>Calisan bilgi formu</h4>
                </div>
                <p className="modern-hr-widget-subtitle">
                  Rehber gorunurlugu, temel profil alanlari ve ilk gun hazirlik bilgileri ayni kayitta tutulur.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="modern-hr-form">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="modern-hr-section">
                      <h5 className="modern-hr-section-title">
                        <i className="bx bx-id-card"></i>
                        Kisisel bilgiler
                      </h5>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Ad</label>
                        <input
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          className="modern-hr-form-input"
                          required
                        />
                      </div>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Soyad</label>
                        <input
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          className="modern-hr-form-input"
                          required
                        />
                      </div>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Kurum e-postasi</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          className="modern-hr-form-input"
                          placeholder="ad.soyad@kolin.com.tr"
                          required
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="modern-hr-form-group">
                            <label className="modern-hr-form-label">Telefon</label>
                            <input
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                              className="modern-hr-form-input"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="modern-hr-form-group">
                            <label className="modern-hr-form-label">Dahili numara</label>
                            <input
                              name="extension"
                              value={formData.extension}
                              onChange={handleInputChange}
                              className="modern-hr-form-input"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="modern-hr-form-group">
                            <label className="modern-hr-form-label">Dogum tarihi</label>
                            <input
                              type="date"
                              name="birthDate"
                              value={formData.birthDate}
                              onChange={handleInputChange}
                              className="modern-hr-form-input"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="modern-hr-form-group">
                            <label className="modern-hr-form-label">Acil durum iletisimi</label>
                            <input
                              name="emergencyContact"
                              value={formData.emergencyContact}
                              onChange={handleInputChange}
                              className="modern-hr-form-input"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Adres</label>
                        <textarea
                          name="address"
                          value={formData.address}
                          onChange={handleInputChange}
                          className="modern-hr-form-textarea"
                          rows="3"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="modern-hr-section">
                      <h5 className="modern-hr-section-title">
                        <i className="bx bx-briefcase-alt"></i>
                        Is ve rehber bilgileri
                      </h5>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Departman</label>
                        <select
                          name="department"
                          value={formData.department}
                          onChange={handleInputChange}
                          className="modern-hr-form-select"
                          required
                        >
                          <option value="">Departman secin</option>
                          {departmentOptions.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Pozisyon</label>
                        <input
                          name="position"
                          value={formData.position}
                          onChange={handleInputChange}
                          className="modern-hr-form-input"
                          required
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="modern-hr-form-group">
                            <label className="modern-hr-form-label">Ise baslama tarihi</label>
                            <input
                              type="date"
                              name="startDate"
                              value={formData.startDate}
                              onChange={handleInputChange}
                              className="modern-hr-form-input"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="modern-hr-form-group">
                            <label className="modern-hr-form-label">Ofis / lokasyon</label>
                            <input
                              name="officeLocation"
                              value={formData.officeLocation}
                              onChange={handleInputChange}
                              className="modern-hr-form-input"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Kisa biyografi</label>
                        <textarea
                          name="bio"
                          value={formData.bio}
                          onChange={handleInputChange}
                          className="modern-hr-form-textarea"
                          rows="3"
                          placeholder="Rehberde gosterilecek kisa tanitim metni"
                        />
                      </div>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Uzmanlik alanlari</label>
                        <input
                          name="expertise"
                          value={formData.expertise}
                          onChange={handleInputChange}
                          className="modern-hr-form-input"
                          placeholder="Planlama, saha yonetimi, raporlama"
                        />
                      </div>

                      <div className="form-check mb-3">
                        <input
                          id="directoryVisible"
                          name="directoryVisible"
                          type="checkbox"
                          checked={formData.directoryVisible}
                          onChange={handleInputChange}
                          className="form-check-input"
                        />
                        <label htmlFor="directoryVisible" className="form-check-label">
                          Calisan rehberinde gorunur olsun
                        </label>
                      </div>
                    </div>

                    <div className="modern-hr-section">
                      <h5 className="modern-hr-section-title">
                        <i className="bx bx-lock-alt"></i>
                        Giris bilgileri
                      </h5>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Sifre</label>
                        <input
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          className="modern-hr-form-input"
                          required
                        />
                      </div>

                      <div className="modern-hr-form-group">
                        <label className="modern-hr-form-label">Sifre tekrari</label>
                        <input
                          type="password"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleInputChange}
                          className="modern-hr-form-input"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modern-hr-form-actions">
                  <button
                    type="button"
                    className="modern-hr-btn modern-hr-btn-secondary"
                    onClick={() => window.history.back()}
                  >
                    Geri don
                  </button>
                  <button type="submit" className="modern-hr-btn modern-hr-btn-primary" disabled={loading}>
                    {loading ? 'Kaydediliyor...' : 'Calisani kaydet'}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="col-xl-4">
            <div className="modern-hr-widget mb-4">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-git-branch"></i>
                  <h4>Onboarding akisi</h4>
                </div>
                <p className="modern-hr-widget-subtitle">
                  Kayit acildiktan sonra ilerleyen 30 gunluk sorumluluk omurgasi
                </p>
              </div>

              <div className="d-flex flex-column gap-3">
                {onboardingJourney.map((step) => (
                  <div key={step.id} className="hr-job-card">
                    <div className="hr-job-card-top">
                      <span className="hr-job-badge">{step.timeline}</span>
                      <small>{step.owner}</small>
                    </div>
                    <h5>{step.title}</h5>
                    <p>{step.tasks.join(' • ')}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-link-alt"></i>
                  <h4>Hazirlik kanallari</h4>
                </div>
              </div>

              <div className="hr-system-links">
                {hrSystems.map((system) =>
                  system.isExternal ? (
                    <a
                      key={system.key}
                      href={system.href}
                      className="hr-system-link-card"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className={system.icon}></i>
                      <div>
                        <strong>{system.title}</strong>
                        <span>{system.subtitle}</span>
                        <small>{system.ctaLabel}</small>
                      </div>
                    </a>
                  ) : (
                    <Link key={system.key} to={system.href} className="hr-system-link-card">
                      <i className={system.icon}></i>
                      <div>
                        <strong>{system.title}</strong>
                        <span>{system.subtitle}</span>
                        <small>{system.helperText}</small>
                      </div>
                    </Link>
                  )
                )}
              </div>

              <div className="mt-4">
                <Link className="modern-hr-btn modern-hr-btn-secondary w-100" to={ROUTE_PATHS.hr}>
                  IK merkezine geri don
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default YeniCalisanPage;
